import { render, staticRenderFns } from "./ModalSelecionarLocalidadeOnccaAR.vue?vue&type=template&id=5afd914f&lang=pug"
import script from "./ModalSelecionarLocalidadeOnccaAR.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarLocalidadeOnccaAR.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarLocalidadeOnccaAR.vue?vue&type=style&index=0&id=5afd914f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports